import React from 'react';
import cx from 'classnames';
import LinkV2, { LinkV2Props } from '../../LinkV2/LinkV2';
import styles from './cartItemName.module.less';

export const CartItemNamePriceWrapper = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={cx(styles.cartItemNamePriceWrapper, className)} {...rest} />;
};

export const CartItemName = ({
  children,
  className,
  smallerFont = false,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & { smallerFont?: boolean }) => {
  return (
    <div
      className={cx(styles.cartItemName, { [styles.smaller]: smallerFont }, className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const CartItemNameLink = ({ className, ...rest }: LinkV2Props) => {
  return <LinkV2 className={cx(styles.cartItemName, className)} {...rest} />;
};
